module.exports = __webpack_public_path__ + "img/icons_home.9bf05da8.svg";